import { Stack, Avatar, Typography, TextField, RadioGroup, FormControlLabel, Radio } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { alert } from "src/services/alert";
import FormDialog from "../common/FormDialog";
import FormItem from "../form-item/FormItem";
import UserInfo from "../common/UserInfo";
import { asyncRequest } from "src/services/network";
import MerchantPicker from "../common/MerchantPicker";
import UserPicker from "../common/UserPicker";
import Confirm from "../common/ConfirmDialog";
import { useEffect } from "react";
import TreeSelect from "../lib/tree-select/TreeSelect";

const StaffAddDialog = ({ action, staff, open, onClose, onUpdate }) => {
  const [form, setForm] = useState({
    uid: "",
    orgId: "",
  });

  const [user, setUser] = useState({});

  const [categoryTree, setCategoryTree] = useState([]);

  useEffect(() => {
    if (action !== 'edit') return;
    
    setForm({
      uid: staff.uid,
      orgId: staff.orgId || ''
    })
    setUser(staff)
  }, [staff]);

  useEffect(() => {
    getCategories(true);
  }, []);

  async function getCategories() {
    const { data } = await asyncRequest({
      method: "get",
      path: "/user/org/all",
    });

    setCategoryTree(data);
  }

  function handleIptChange(ki, val) {
    // console.log(ki, val);
    setForm({
      ...form,
      [ki]: val,
    });
  }

  async function handleConfirm() {
    if (!user.uid) return alert("请选择用户");
    if (!form.orgId) return alert("请选择职位");

    const { msg } = await asyncRequest({
      path: "/user/staff/add",
      data: {
        ...form,
        uid: user.uid,
      },
    });

    alert(msg, "success");
    onUpdate();
  }

  function handleSelectUser() {
    UserPicker({
      onSelect(val) {
        console.log(val);
        setUser(val);
      },
    });
  }

  return (
    <FormDialog title="添加员工" open={open} onClose={onClose} onConfirm={handleConfirm}>
      <FormItem title="用户" required>
        <Stack onClick={handleSelectUser}>
          <UserInfo {...user} />
        </Stack>
      </FormItem>

      <FormItem title="职位" required>
        <TreeSelect
          data={categoryTree}
          value={form.orgId}
          // maxLevel={action === "add" ? row.level : row.level - 1}
          onChange={(v) => handleIptChange("orgId", v)}
          topLabel=""
        />
      </FormItem>
    </FormDialog>
  );
};

export default StaffAddDialog;
